import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Logo from "../../../src/assets/images/logo-young-type.png";
import FooterList from "../../components/footer-list/footer-list.component";
import "./footer.styles.css";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";
import { SiGmail } from "react-icons/si";
import {
  FaTelegramPlane,
  FaWhatsapp,
  FaPhoneAlt,
  FaInstagramSquare,
} from "react-icons/fa";

const Footer = () => {
  // to persian
  const toPersianNumber = (number) => {
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return number.toString().replace(/\d/g, (digit) => persianDigits[digit]);
  };

  const footerData = [
    {
      title: "لینک سریع",
      items: [
        { text: "خانه", link: "/" },
        { text: "فروشگاه", link: "/shop" },
        { text: "درباره ما", link: "/about" },
        { text: "ارتباط با ما", link: "/contact" },
      ],
    },
    {
      title: "لینک سریع",
      items: [
        { text: "درباره یانگ", link: "/about-us-page" },
        { text: "ارتباط با ما ", link: "/contact-us-page" },
      ],
    },
    {
      title: "قوانین مقررات",
      items: [
        { text: "قوانین و مقررات", link: "/privacy-policy-page" },
        { text: "سوال متداول", link: "/faq-page" },
      ],
    },
  ];

  return (
    <Fragment>
      <Outlet />
      <div className="footer">
        <div className="footer-column footer-big-column">
          <img className="footer-logo" src={Logo} alt="img" />
          {/* <h2 className="logo-title-footer">YOUNG</h2> */}
          <strong className="footer-main-text">
            {/* اینجا جای آدمای معمولی نیست{" "} */}
          </strong>
        </div>

        {/* <div className='enamd-section'>
          <a
            referrerPolicy='origin'
            target='_blank'
            rel='noopener noreferrer'
            href='https://trustseal.enamad.ir/?id=454918&Code=Ilsmn8YcyThnrpVCCCgKsvnSPGN3Eyrx'
          >
            <img
              referrerPolicy='origin'
              src='https://trustseal.enamad.ir/logo.aspx?id=454918&Code=Ilsmn8YcyThnrpVCCCgKsvnSPGN3Eyrx'
              alt='Enamad Badge'
              style={{ cursor: 'pointer' }}
              code='Ilsmn8YcyThnrpVCCCgKsvnSPGN3Eyrx'
            />
          </a>
        </div> */}

        {/* Render FooterList in the small-column divs */}
        <div className="footer-column footer-small-column">
          <FooterList cat={footerData[1]} /> {/* Customer Service */}
        </div>
        <div className="footer-column footer-small-column">
          <FooterList cat={footerData[2]} /> {/* Legal */}
        </div>
        <div className="footer-column footer-big-column">
          <h5 className="footer-detail-call mn-bn-6">شماره تماس :</h5>
          <div className="footer-contact-row">
            <h5 className="footer-detail-call">
              {toPersianNumber("09108794329")}
            </h5>
            <a
              href="tel:+989108794329"
              className="footer-contact-icon call-icon"
              title="تماس مستقیم"
            >
              <BsFillTelephoneFill />
            </a>
            <a
              href="https://t.me/youngstoring"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-icon telegram-icon"
              title="تلگرام"
            >
              <FaTelegramPlane />
            </a>
            <a
              href="https://wa.me/989108794329"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-icon whatsapp-icon"
              title="واتس‌اپ"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.instagram.com/youngstoring"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-icon instagram-icon"
              title="اینستاگرام"
            >
              <FaInstagramSquare />
            </a>
          </div>
          <h5 className="footer-detail-call mn-bn-6">
            آدرس : تهران، میدان قدس، خیابان چمن، کوچه کیهان،
            <br /> سر بن‌بست گلها - کدپستی: {toPersianNumber("3754115002")}
          </h5>
        </div>
      </div>
      <div className="footer-copy-right-text-wrapper">
        <p className="footer-copy-right-text">
          © 2025 <a href="https://senpaicoders.com/">senpaiCoders</a>, All
          Rights Reserved
        </p>
      </div>
    </Fragment>
  );
};

export default Footer;
